import messages from '../locales/bg_BG.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'bg-BG',
};
export default lang;
